var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 757.64 896.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f1f1f1;}.cls-2{fill:#e49d75;}.cls-3{fill:#5fc5d1;}.cls-4{fill:#6bd5e1;}.cls-5{fill:#e0e0e0;}.cls-6{fill:#a4a4a4;}.cls-7{fill:none;stroke:#e0e0e0;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px;}.cls-8{fill:#ffd98e;}.cls-9{fill:#ffe4ad;}.cls-10{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unlock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M636.5,232.73c68.06,61.33,93.17,180.88,67.33,286.61C677.81,625.07,601,717,496,778.29c-105,61.14-238,91.9-326.82,43.86S36.17,647.63,13.78,523.53c-22.2-124.11-22.56-245.67,36.58-305C109.5,159.4,228,162.31,342.79,165.22,457.62,168.31,568.62,171.41,636.5,232.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 558.8,
    y: 858.32,
    width: 22.08,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 677.14,
    y: 835.57,
    width: 20.72,
    height: 18.36,
    transform: "translate(-378.13 619.59) rotate(-38.93)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 586.33,
    y: 256.37,
    width: 17.47,
    height: 20.69,
    rx: 8.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M602.4,567.42c3,6.88,26,144.94,29.38,158s57.45,98.2,61.13,103.29c1.13,7.36-15.57,19.81-23.49,19.81C661.5,842.26,569,708.23,566.78,702.28S557.11,553.94,602.4,567.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M505.83,544.55c-1.05,5.7,14.58,136,16.52,153.5s31.89,158.48,34.54,162,22.81,2.76,26.29,1-6.8-147-6.8-157.53,27-107.65,23.53-135.78S505.83,544.55,505.83,544.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 561.36,
    y: 386.6,
    width: 21.11,
    height: 36.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 94.97,
    y: 137.85,
    width: 379.57,
    height: 379.57,
    rx: 22.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.48,310.8a35.09,35.09,0,1,0-47.45,0L234,420.41H335.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M162.9,137.85a121.86,121.86,0,0,1,243.71,0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 569.19,
    cy: 353.64,
    rx: 29,
    ry: 39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M565.24,415.77c-35.16,0-66.5,97.54-60.48,129.91,1.78,9.56,85.92,28.85,98.78,26.15C608.11,565.61,626.76,415.77,565.24,415.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M556.22,470.1c15.74-11.42-9.42-66.76-15.3-67.71-10.83-1.75-37.76,19-36.91,27.72C504.46,434.71,540.19,481.73,556.22,470.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509,426c-4.24-5.09-14.84-30-16-35.91s-4-94.74-4-100S482,271.56,482,263.64s8.06-18.66,12.16-18.8c4.38,3.11,10.46,21.35,10.74,26,1.53-10,8.77-12.3,10.75-12.3s1.72,15.45-6.48,25.85c.29,7.64,10,83.31,11.57,87.69s19.45,33.09,19.41,35.63S509,426,509,426Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 368.05,
    y: 260.35,
    width: 358.11,
    height: 10.23,
    transform: "translate(40.99 -71.64) rotate(7.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 366.9,
    y: 247.63,
    width: 21.9,
    height: 29.63,
    transform: "translate(39.02 -48.75) rotate(7.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 397.87,
    y: 251.17,
    width: 11.78,
    height: 29.63,
    transform: "translate(39.74 -52.22) rotate(7.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M604.74,334c-.83-4.74-1.58-39.09-.3-43.94s4.74-8.39,6.29-15.63c.53-2.49-.31-11.11-2-11.47-3.64-.78-3.85,3.3-4.33,6.3-1.86,10.23-5.65,8.36-7.4,8.12s-7.76-1.28-9.73-1.33,3.05,4,1.52,10.47c-1.2,5.09-6.84,39-8,44.55C585,331.24,604.74,334,604.74,334Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 417.79,
    y: 253.89,
    width: 11.78,
    height: 29.63,
    transform: "translate(40.29 -54.9) rotate(7.78)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 368.01,
    y: 250.51,
    width: 63.09,
    height: 10.5,
    transform: "translate(38.31 -51.75) rotate(7.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M734.69,264.08A26.54,26.54,0,1,0,757.4,294,26.54,26.54,0,0,0,734.69,264.08ZM749,292.82a18.07,18.07,0,1,1-15.45-20.35A18.07,18.07,0,0,1,749,292.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M509.28,284.31c-1.32-5.17-3.89-9.69-4.31-13.58l0,.12c-.28-4.66-6.36-22.9-10.74-26-4.1.14-12.16,10.88-12.16,18.8,0,5.81,3.8,14.5,5.82,20.79h21.35v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.06,329.21c0,13.49,9.52,21.81,24.61,26.45,0,18.46,2.85,19.27,2.85,30.51,0,24.22-4.13,12.11-4.13,53.93,0,25.22,10.56,38.94,30,38.94,23.51,0,37-24.87,37-38.27,0-17-16.82-46.54-18-71.07-1.63-33-11.89-60.61-37.62-60.61C555.79,309.09,543.06,317.27,543.06,329.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 569.16,
    cy: 358.82,
    r: 7.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M701.29,842.49l12.5,17.06-26.15,37-24.68.16.32-12.51,9.91-4.38L682,858.08Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "582.36 871.83 582.36 896.74 509.14 896.74 509.14 885.71 557.45 871.83 582.36 871.83"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.950028eab11c94e30b25079a4a1b4fcb.svg";
export { ForwardRef as ReactComponent };